<template>
    <div class="document-modal document input-full-width">
        <div class="modal-header">
            <h2 class="text-center">{{editedData.name}}</h2>
        </div>

        <div class="form">
            <div class="grid-x align-items">
                <div class="cell small-2 medium-1 large-1 flexbox-center">
                    <icon class="bubble small-svg" name="bubble" />
                </div>
                <div class="cell auto">
                    <div class="grid-x align-items">
                        <div class="cell small-5 medium-3 large-3">
                            <label for="documentNote">Note</label>
                        </div>
                        <div class="cell auto border-bottom">
                            <p class="text-area">{{editedData.description}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <div class="text-center modal-buttons">
                <button type="button" class="button-naked" @click="closeModal()">Luk</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'document-modal-read-only-description',
    props: {
        data: Object
    },
    data () {
        return {
            editedData: Object.assign({}, this.data)
        }
    },
    methods: {
        closeModal () {
            this.$emit('close')
        },
        updateDocument () {
            this.data.description = this.editedData.description
            this.data.updating = true
            this.closeModal()
        }
    },
    created () {
        this.data.updating = false
    }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/fileupload/document-modal-read-only-description.vue